import { Container, Box, Heading } from '@hover/blueprint';
import React from 'react';
import { useInterSectionObserver } from '../../../hooks';

interface Props {
  setCurrentSection: React.Dispatch<React.SetStateAction<string>>;
}

const CareersOurPeople: React.FC<Props> = ({ setCurrentSection }) => {
  const ourPeopleRef = useInterSectionObserver(
    isIntersecting => {
      if (isIntersecting) {
        setCurrentSection('Our People');
      }
    },
    {
      rootMargin: '0px',
      threshold: 1,
      root: null,
    },
  );

  return (
    <Container
      ref={ourPeopleRef.elementRef}
      maxW="5xl"
      position="relative"
      pt={97}
      pb={97}
    >
      <Box
        id="careers-our-people"
        position={{ desktop: 'absolute' }}
        display={{ base: 'none', desktop: 'block' }}
        w={0}
        h={0}
        top="200px"
      />
      <Box flexDir="column" alignItems="center">
        <Heading
          maxW="5xl"
          size={{ base: 500, desktop: 700 }}
          color="neutral.700"
          textAlign="center"
          isLight
          style={{ marginBottom: 24 }}
        >
          Our People
        </Heading>
        <Container maxW="4xl" px={200}>
          <Heading
            size={{ base: 300, desktop: 500 }}
            color="neutral.700"
            textAlign="center"
            fontWeight={{ base: 400, desktop: 400 }}
            style={{ marginBottom: 0 }}
          >
            HOVER&apos;s employees are our top priority and drive our success.
            That&apos;s why we invest in employee&apos;s personal and
            professional growth, fund and prioritize employee-led diversity and
            inclusion work, and support work-life balance. We are committed to
            building and sustaining a company culture where all HOVERites
            experience a sense of belonging, are inspired by their peers, and
            love their work.
          </Heading>
        </Container>
      </Box>
    </Container>
  );
};

export default CareersOurPeople;
